import * as React from 'react';
import { SubscriberService, OnUpdateEvent, createStaticServiceInstance, createUseZenAutoArtService } from "./base-subscriber-service";
import { BLAZOR_ASSEMBLY } from "@/common/constants";

type AutoArtDesignerMode = "panels" | "artwork";

interface IZenDataObject {
    artworkTrNumber: string;
    artworkWorkflowGuid: string;
    buildVersion: string;
    customerID: number;
    customerName: string;
    customers: PanelDesigner.ICustomer[];
    debugMode: boolean;
    designerMode: AutoArtDesignerMode;
    forceOpen: boolean;
    initialFileToLoad: string;
    userID: number;
}

export default class ZenDataService extends SubscriberService<ZenDataService> {
    public static Get(comp: React.Component, onUpdate?: OnUpdateEvent) {
        return zenDataServiceInstance._RegisterComponent(comp, onUpdate);
    }

    private dataObj: IZenDataObject = {
        artworkTrNumber: "",
        artworkWorkflowGuid: "",
        buildVersion: "-- Loading Version --",
        customerID: -1,
        customerName: "",
        customers: [],
        debugMode: false,
        designerMode: "panels",
        forceOpen: false,
        initialFileToLoad: "",
        userID: -1
    }

    private onDataChangedCallbacks: (() => any)[] = [];

    public constructor() {
        super();
    }

    public Initialize() {
        const urlParams = new URLSearchParams(window.location.search);
        const themeScriptUrls = urlParams.get("_theme_manager_urls")?.trim();

        if (themeScriptUrls && themeScriptUrls.length > 0) {
            for (const url of themeScriptUrls.split(';')) {
                const scriptEl = document.createElement("script");
                scriptEl.src = url;
                document.body.appendChild(scriptEl);
            }
        }
    }

    public SetCustomerID(customerID: number) {
        DotNet.invokeMethod(BLAZOR_ASSEMBLY, 'SetCurrentCustomerID', customerID);
    }
  
    public AddOnDataChangedCallback(callback: () => any) {
        this.onDataChangedCallbacks.push(callback);
    }

    public GetCustomerID() {
        return this.dataObj.customerID;
    }

    public GetCustomerName() {
        return this.dataObj.customerName || this.dataObj.customerID;
    }

    public GetAllCustomers() {
        return this.dataObj.customers;
    }

    public GetUserID() {
        return this.dataObj.userID;
    }

    public GetDesignerMode() {
        return this.dataObj.designerMode;
    }

    public GetPanelDesignerVersion() {
        return 2;
    }

    public GetBuildVersion() {
        return this.dataObj.buildVersion;
    }

    public GetInitialFileToLoad() {
        return this.dataObj.initialFileToLoad;
    }

    public GetForceOpen() {
        return this.dataObj.forceOpen;
    }

    public GetArtworkTrNumber() {
        return this.dataObj.artworkTrNumber;
    }

    public GetArtworkWorkflowGuid() {
        return this.dataObj.artworkWorkflowGuid;
    }

    public IsInDebugMode() {
        return this.dataObj.debugMode;
    }

    public refreshData(data: IZenDataObject) {
        data.designerMode = data.designerMode.toLowerCase();
        this.dataObj = data;
        this._UpdateSubscribers();
        for(const callback of this.onDataChangedCallbacks) {
            callback();
        }
    }
}

export const zenDataServiceInstance = createStaticServiceInstance(new ZenDataService(), "zenDataService");

// For React Functional Components
export const useZenDataService = createUseZenAutoArtService(zenDataServiceInstance);
